/*###########################################################################
// Kitchen visualiser tracking
//#########################################################################*/

const trackedEvents = {
	'get-started': 'kitchen_visualiser_get_started',
	'save-design': 'kitchen_visualiser_save_design',
	'form-submit': 'kitchen_visualiser_form_submit'
}

const pushGa4Event = (eventName) => {
	if (typeof window.gtag === 'function') {
		window.gtag('event', eventName)
		return
	}

	if (Array.isArray(window.dataLayer)) {
		window.dataLayer.push({
			event: eventName
		})
	}
}

const bindKitchenVisualiserEvents = () => {
	if (window.__kitchenVisualiserTrackingBound === true) {
		return
	}

	window.__kitchenVisualiserTrackingBound = true

	Object.entries(trackedEvents).forEach(([iframeEventName, ga4EventName]) => {
		window.addEventListener(iframeEventName, (event) => {
			console.group(`[kitchen-visualiser] ${iframeEventName}`)
			console.log('type:', event.type)
			console.log('detail:', event.detail)
			console.log('full event:', event)
			console.log('ga4_event_name:', ga4EventName)
			console.log('gtag_available:', typeof window.gtag === 'function')
			console.groupEnd()

			pushGa4Event(ga4EventName)
		})
	})
}

bindKitchenVisualiserEvents()
